export default "__VITE_PUBLIC_ASSET__774951a2__"